import { render, staticRenderFns } from "./AdminChange.vue?vue&type=template&id=02824b35"
import script from "./AdminChange.vue?vue&type=script&lang=js"
export * from "./AdminChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports